import React from 'react';
import { BubbleNavigation } from '../BubbleUI';
import { resolveGroupResourcesPath, resolveGroupsPath } from '@go-client/routes';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';

export default function GroupsNavigation(props: { active: 'bookings' | 'groups' | 'resources' }) {
  const { activeProperty } = useActiveProperty();

  return (
    <BubbleNavigation
      items={[
        {
          name: 'Groups',
          to: resolveGroupsPath(activeProperty._id, 'parties'),
          active: props.active === 'groups',
          variant: 'forest',
        },
        {
          name: 'Group Bookings',
          to: resolveGroupsPath(activeProperty._id, 'bookings'),
          active: props.active === 'bookings',
          variant: 'forest',
        },
        {
          name: 'Resources',
          to: resolveGroupResourcesPath(activeProperty._id),
          active: props.active === 'resources',
          variant: 'forest',
        },
      ]}
    />
  );
}
